const menupermissions = r => require.ensure([], () => r(require('../../views/systemmanagement/menupermissions/menupermissions.vue')), 'menupermissions')
const rolemanagement = r => require.ensure([], () => r(require('../../views/rolemanagement/rolemanagement.vue')), 'rolemanagement')
const departmentmanagement = r => require.ensure([], () => r(require('../../views/departmentmanagement/departmentmanagement.vue')), 'departmentmanagement')
const rolemanagementpermissionlist = r => require.ensure([], () => r(require('../../views/rolemanagementpermissionlist/rolemanagementpermissionlist.vue')), 'rolemanagementpermissionlist')
const permissionlist = r => require.ensure([], () => r(require('../../views/permissionlist/permissionlist.vue')), 'permissionlist')
const menumanagement = r => require.ensure([], () => r(require('../../views/menumanagement/menumanagement.vue')), 'menumanagement')
const menupermissionss = r => require.ensure([], () => r(require('../../views/menupermissions/menupermissions.vue')), 'menupermissions')
const UserLoginLog =  r => require.ensure([], () => r(require('../../views/UserLoginLog/index.vue')), 'UserLoginLog')
const OperateLog =  r => require.ensure([], () => r(require('../../views/OperateLog/index.vue')), 'OperateLog')


const UAChildrenRouter = [
    {
        path: '/UA/UserInfo',
        name: 'menupermissions',
        component: menupermissions,
        meta: {
            typePage: 2
        }
        
    },
    {
        path: '/UA/Role',
        name: 'rolemanagement',
        component: rolemanagement,
        meta: {
            typePage: 2
        }
        
    },
    {
        path: '/UA/OrganizationManage',
        name: 'departmentmanagement',
        component: departmentmanagement,
        meta: {
            typePage: 2
        }
    },
    {
        path: '/UA/Authorities',
        name: 'rolemanagementpermissionlist',
        component: rolemanagementpermissionlist,
        meta: {
            typePage: 2
        }
    },
    {
        path: '/UA/AuthorityList',
        name: 'permissionlist',
        component: permissionlist,
        meta: {
            typePage: 2
        }
        
    },
    {
        path: '/UA/MenuList',
        name: 'menumanagement',
        component: menumanagement,
        meta: {
            typePage: 2
        }
        
    },
    {
        path: '/UA/MenuAuthority',
        name: 'menupermissionss',
        component: menupermissionss,
        meta: {
            typePage: 2
        }
    },
    {
        path: '/UA/UserLoginLog',
        name: 'UserLoginLog',
        component: UserLoginLog,
        meta: {
            typePage: 2
        }
    },
    {
        path: '/UA/OperateLog',
        name: 'OperateLog',
        component: OperateLog,
        meta: {
            typePage: 2
        }
    },
];
export default UAChildrenRouter
